<div class="content_video">
    <video width="100%" playsinline controls>
        <source src="{{ video.mp4.path }}" type="video/mp4"/>
        <source src="{{ video.webm.path }}" type="video/webm"/>
        <source src="{{ video.ogv.path }}" type="video/ogg"/>
        <img src="{{ video.waitingImage.path }}" alt="" title="">
    </video>
</div>
